import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "FilterBox" })
export default class FilterBox extends Vue {
    public localizer: any = Localizer;
    public isTagListVisible: boolean = true;
    public isDownloadModeListVisible: boolean = true;
    public isCollectionListVisible: boolean = true;
    public filterData: any = { collections: [], tags: [] };
    public collectionIndex: number = 5;
    public tagIndex: number = 5;
    public selectedTags: string[] = [];
    public filters: any[] = [];
    public downloadModes: any[] = [];
    public selectedDownloadMode: string = null;
    public selectedFilter: string = null;
    public isShow: boolean = false;
    public isLoading: boolean = false;
    public activatedFilters: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get selectedCollection() {
        return this.collection ? this.filterData.collections.find(x => x.name === this.collection) : null;
    }

    get isContentLoading(): any {
        return this.$store.getters["catalogueStore/isContentLoading"];
    }

    @Prop() readonly collection: string;

    public async created() {
        await this.getData();
    }

    public async getData() {
        const urlParams = new URLSearchParams(window.location.search);
        this.selectedFilter = urlParams.get("selectedfilter");

        let encodedfilters = urlParams.get("filters");
        this.$store.commit("catalogueStore/setEncodedFilters", encodedfilters);

        this.isLoading = true;

        this.filterData = (await Axios.post(this.routes.DigitalCatalogue_Catalogue_GetFilterBoxData, { collectionName: this.collection, filters: encodedfilters })).data;
        this.filters = this.filterData.filters;
        this.downloadModes = this.filterData.downloadModes;

        this.setActivatedFilters();

        this.isLoading = false;
    }

    public openUrl(url: string) {
        window.location.href = url;
    }

    public setFilter(name: string, value: any) {
        this.filters = this.filters.filter(x => x.name !== name);
        if (value) {
            this.filters.push({ name: name, value: value });
        }

        this.setActivatedFilters();

        this.openFilterUrl();
    }

    public setActivatedFilters() {
        this.activatedFilters = [];
        for (const filter of this.filters) {
            let selectedValues = filter.value.split(',').map((x: any) => { return { title: filter.name, value: x } });
            this.activatedFilters.push(...selectedValues);
        }

        this.activatedFilters.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
    }

    public convertString(inputRange: string) {
        const parts = inputRange.split(',');

        const convertedParts = parts.map(part => parseFloat(part).toString());

        return convertedParts.join(',');
    }

    public encodeFilters(): string {
        return window.btoa(this.filters.map(x => x.name + ":" + x.value).join(";"));
    }

    public openFilterUrl() {
        if (this.filters.length !== 0) {
            if ("URLSearchParams" in window) {
                let encodedFilters = this.encodeFilters();

                let searchParams = new URLSearchParams(window.location.search);
                searchParams.set("filters", encodedFilters);

                this.$store.commit("catalogueStore/setEncodedFilters", encodedFilters);

                history.pushState({}, '', `${location.pathname}?${searchParams}`);
            }
        } else {
            this.removeFilters();
        }
    }

    public removeFilterValue(filter: any) {
        let removedFilter = this.activatedFilters.find(x => x.title === filter.title && x.value === filter.value);
        this.activatedFilters = this.activatedFilters.filter(x => (x.title !== filter.title && x.value !== filter.value) || (x.title === filter.title && x.value !== filter.value));

        let index = this.filters.findIndex(x => x.name === filter.title);

        if (removedFilter.title === this.filters[index].name) {
            let newValue = this.filters[index].value.split(',').filter(item => item !== removedFilter.value);
            this.filters[index].value = newValue.join(',');

            this.setFilter(this.filters[index].name, this.filters[index].value);
        }
    }

    public removeFilters() {
        this.filters = [];
        this.selectedTags = [];

        this.$store.commit("catalogueStore/setEncodedFilters", null);

        this.setActivatedFilters();

        history.pushState({}, '', `${location.pathname}`);
    }

    public setIsTagListVisible() {
        this.isTagListVisible = !this.isTagListVisible;
    }

    public setIsDownloadModeListVisible() {
        this.isDownloadModeListVisible = !this.isDownloadModeListVisible;
    }

    public setIsCollectionListVisible() {
        this.isCollectionListVisible = !this.isCollectionListVisible;
    }

    public setShow() {
        this.isShow = !this.isShow;
    }

    public async setTagFilter(value: any) {
        let filter = this.filters.find(x => x.name === "Tag");

        if (filter?.value) {
            this.selectedTags = filter.value.split(",");
        }

        if (this.selectedTags.some(x => x === value)) {
            this.selectedTags = this.selectedTags.filter(x => x !== value);
        } else {
            this.selectedTags.push(value);
        }

        this.setFilter("Tag", this.selectedTags.length !== 0 ? this.selectedTags.join(",") : null);
    }

    public async setDownloadModeFilter(value: any) {
        this.setFilter("DownloadMode", value);
    }

    public getFilterTitle(filter: any): string {
        let selectedFilter = this.filterData.tags.find(x => x.value === filter.value);

        if (!selectedFilter) {
            return filter.value;
        }

        return selectedFilter.title;
    }

    public checkTagSelected(value: string): boolean {
        let selectedTags = this.activatedFilters.filter(x => x.title === 'Tag');
        let selectedValue = selectedTags.some(x => x.value === value);
        return selectedValue;
    }

    public checkDownloadModeSelected(value: string): boolean {
        let selectedDownloadModes = this.activatedFilters.filter(x => x.title === 'DownloadMode');
        let selectedValue = selectedDownloadModes.some(x => x.value === value);
        return selectedValue;
    }
};